import axios from "axios";
import Cookies from "universal-cookie";

const API_URL = "https://www.dzayerna.com/api";

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: false,
});

// Intercepteur pour ajouter le token d'authentification
apiClient.interceptors.request.use(
  (config) => {
    const cookies = new Cookies();
    const token = cookies.get("token");
    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les réponses et les erreurs
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const cookies = new Cookies();
    // Gestion des erreurs comme l'expiration de session, etc.
    if (error.response && error.response.status === 401) {
      // Rediriger vers la page de connexion en cas d'expiration de session
      cookies.remove("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Services API pour le dictionnaire
const dictionaryService = {
  getAllEntries: (params) => apiClient.get("/dictionary/entries/", { params }),
  getEntry: (id) => apiClient.get(`/dictionary/entries/${id}`),
  createEntry: (data) => apiClient.post("/dictionary/entries/", data),
  updateEntry: (id, data) => apiClient.put(`/dictionary/entries/${id}/`, data),
  deleteEntry: (id) => apiClient.delete(`/dictionary/entries/${id}/`),
  validateEntry: (id) => apiClient.post(`/dictionary/entries/${id}/validate/`),
  rejectEntry: (id) => apiClient.post(`/dictionary/entries/${id}/reject/`),
  getCommentsByEntry: (entryId) => {
    const params = { entry_id: entryId };
    return apiClient.get("/dictionary/comments/", { params });
  },
  getComments: (params) => {
    return apiClient.get("/dictionary/comments/", { params });
  },
  addComment: (data) => {
    return apiClient.post("/dictionary/comments/", data);
  },
  createSuggestion: (data) => apiClient.post("/dictionary/suggestions/", data),
  approveSuggestion: (id) =>
    apiClient.post(`/dictionary/suggestions/${id}/approve/`),
  rejectSuggestion: (id) =>
    apiClient.post(`/dictionary/suggestions/${id}/reject/`),
};

// Services API pour les projets
const projectService = {
  // getAllProjects: (params) => apiClient.get('/projects/projects/', { params }),
  getAllProjects: (params) => apiClient.get("/projects/projects/", { params }),

  // getProject: (id) => apiClient.get(`/projects/projects/${id}/`),
  getProject: (id) => apiClient.get(`/projects/projects/${id}/`),

  // createProject: (data) => apiClient.post('/projects/projects/', data),
  createProject: (data) => apiClient.post("/projects/projects/", data),
  // updateProject: (id, data) => apiClient.put(`/projects/projects/${id}/`, data),
  updateProject: (id, data) => apiClient.put(`/projects/projects/${id}/`, data),
  // deleteProject: (id) => apiClient.delete(`/projects/projects/${id}/`),
  validateProject: (id) => apiClient.post(`/projects/projects/${id}/validate/`),
  rejectProject: (id) => apiClient.post(`/projects/projects/${id}/reject/`),
  deleteProject: (id) => apiClient.delete(`/projects/projects/${id}/`),
  getComments: (projectId) =>
    apiClient.get("/projects/comments/", { params: { project: projectId } }),
  addComment: (data) => apiClient.post("/projects/comments/", data),
  getResources: (projectId) =>
    apiClient.get("/projects/resources/", { params: { project: projectId } }),
  addResource: (data) =>
    apiClient.post("/projects/resources/", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
  approveResource: (id) => apiClient.post(`/projects/resources/${id}/approve/`),
  rejectResource: (id) => apiClient.post(`/projects/resources/${id}/reject/`),
};

// Services API pour les utilisateurs
const userService = {
  // login: (credentials) => apiClient.post('/api-token-auth/', credentials),
  login: (credentials) => apiClient.post("/users/login/", credentials),

  register: (userData) => apiClient.post("/users/register/", userData),
  getCurrentUser: () => {
    const res = apiClient.get("/users/users/me/", {
      params: { _t: Date.now() },
    });
    return res;
  },
  updateProfile: (id, data) => apiClient.put(`/users/users/${id}/`, data),
  changeRole: (id, role) =>
    apiClient.post(`/users/users/${id}/change_role/`, { role }),
  getUsers: (params) =>
    apiClient.get("/users/users/", { params }),
};

export const getDashboardStats = () =>
  apiClient.get("/users/dashboard_stats/").then((res) => res.data);

export { dictionaryService, projectService, userService };
